import { render, staticRenderFns } from "./PrefixMaintenanceForm.vue?vue&type=template&id=41472a35&scoped=true&"
import script from "./PrefixMaintenanceForm.vue?vue&type=script&lang=js&"
export * from "./PrefixMaintenanceForm.vue?vue&type=script&lang=js&"
import style0 from "./PrefixMaintenanceForm.vue?vue&type=style&index=0&id=41472a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41472a35",
  null
  
)

export default component.exports